import { createContext, useContext } from 'react'

export const LoggedInUserCompanyPermissionsContext = createContext<string[]>([])
export const useLoggedInUserCompanyPermissions = () =>
  useContext(LoggedInUserCompanyPermissionsContext)
